export default function clientMiddleware(client) {
  return ({dispatch, getState}) => {
    return next => action => {
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      const { promise, types, actionTypes, ...rest } = action; // eslint-disable-line no-redeclare
      
      if (!promise) {
        return next(action);
      }

      const [REQUEST, SUCCESS, FAILURE] = types || actionTypes;
      next({...rest, type: REQUEST});

      const actionPromise = promise(client);
      actionPromise.then(
        (result) => next({...rest, result, type: SUCCESS}),
        (error) => {
          if(error.statusCode === 403){
            console.log('Bạn chưa có quyền thực hiện thao tác này');
          }
          next({...rest, error, type: FAILURE});
        }
      ).catch((error)=> {       
        console.error('MIDDLEWARE ERROR:', error);
        next({...rest, error, type: FAILURE});
      });

      return actionPromise;
    };
  };
}
